import { IAppState } from '../../../AppModulesWrapper';

export function selectIsTermsDurationsAvailable(state: IAppState): boolean {
  return !!state.servicePickerWidget.termsDurations.durations.length;
}
